/** User-global Single Source of Truth document list (stored in user_profiles.preferences). */

export const MAX_SOURCE_OF_TRUTH_DOCS = 8;

export const SOURCE_OF_TRUTH_STORAGE_KEY = "use_source_of_truth";

export function normalizeSourceOfTruthDocIds(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const id of value) {
    if (typeof id !== "string" || !id.trim()) continue;
    const trimmed = id.trim();
    if (seen.has(trimmed)) continue;
    seen.add(trimmed);
    out.push(trimmed);
    if (out.length >= MAX_SOURCE_OF_TRUTH_DOCS) break;
  }
  return out;
}

export function isSourceOfTruthEnabledFromPrefs(
  prefs: Record<string, unknown> | null,
  docIds: string[]
): boolean {
  if (docIds.length === 0) return false;
  if (prefs?.sourceOfTruthEnabled === false) return false;
  return true;
}
